export const dishes = [  
  {  
    id: "workout-1",  
    name: "Full-Body HIIT",  
    href: "/workout/",  
    imageSrc: "https://www.dmoose.com/cdn/shop/articles/14_Weeks_Full_Body_HIIT_Calorie_Destroyer_Workout___Meal_Plan.png?v=1660221219",  
    imageAlt: "Intense HIIT workout",  
    details: "A fast-paced, calorie-burning session combining bodyweight exercises like burpees, squats, and push-ups. This workout pushes your cardiovascular endurance while engaging multiple muscle groups. Expect explosive movements, high sweat levels, and serious gains in stamina. Great for those who have limited time but want maximum impact. Perfect for shredding fat, boosting metabolism, and getting your heart racing."  
  },  
  {  
    id: "workout-2",  
    name: "Power Yoga",  
    href: "/workout/",  
    imageSrc: "https://ognx.com/cdn/shop/articles/Blogpost_XL_87_880x588_crop_center.png?v=1650614013",  
    imageAlt: "Yoga flow workout",  
    details: "Flow through powerful yoga poses that strengthen the core, improve flexibility, and increase mindfulness while breaking a sweat. This isn’t your average stretch class — it combines strength-building poses with fluid transitions. Master balance and coordination while improving your breath control. Ideal for anyone who wants mental clarity and physical endurance in one session."  
  },  
  {  
    id: "workout-3",  
    name: "Strength Training",  
    href: "/workout/",  
    imageSrc: "https://www.shutterstock.com/image-photo/black-man-dumbbell-row-training-600nw-2276854507.jpg",  
    imageAlt: "Weight training session",  
    details: "Target major muscle groups with compound movements like deadlifts, bench presses, and rows. This strength-building workout helps in toning, sculpting, and creating lean muscle mass. Expect high reps and moderate weights with a focus on proper form. Develop a strong, functional body that supports daily activities and sports."  
  },  
  {  
    id: "workout-4",  
    name: "Cardio Kickboxing",  
    href: "/workout/",  
    imageSrc: "https://blog.afaa.com/hs-fs/hubfs/cardio-kickboxing.jpg?width=600&name=cardio-kickboxing.jpg",  
    imageAlt: "Cardio kickboxing workout",  
    details: "Punch, kick, and sweat your way to better fitness. This dynamic cardio session improves coordination, burns calories, and relieves stress. Feel empowered as you unleash powerful combos against an imaginary opponent. Strengthens the core, increases endurance, and hones mental focus. Great for both beginners and seasoned athletes."  
  },  
  {  
    id: "workout-5",  
    name: "Pilates Core Burner",  
    href: "/workout/",  
    imageSrc: "https://cdn-life.dailyburn.com/life/wp-content/uploads/2015/06/10041538/Pilates-2-Wind-down.gif",  
    imageAlt: "Pilates core workout",  
    details: "Focus on core strength and stability with this low-impact workout. Pilates helps in improving flexibility, alignment, and posture. Engages deep abdominal muscles to create a strong core that supports your entire body. Ideal for rehabilitation, toning abs, and creating a lean physique. Expect slow, controlled movements with precise muscle engagement."  
  },  
  {  
    id: "workout-6",  
    name: "Dance Cardio Blast",  
    href: "/workout/",  
    imageSrc: "https://i.ytimg.com/vi/oixHq2zjgUg/maxresdefault.jpg",  
    imageAlt: "Dance cardio workout",  
    details: "Get your heart pumping with fun, high-energy dance moves set to upbeat music. Perfect for those who want to burn calories without feeling like they’re working out. Learn simple but energetic routines that improve rhythm, coordination, and confidence. Expect to groove, sweat, and smile your way to better fitness."  
  },  
  {  
    id: "workout-7",  
    name: "Tabata Workout",  
    href: "/workout/",  
    imageSrc: "https://jackcityfitness.com/wp-content/uploads/Tabata-workout.jpg",  
    imageAlt: "High-intensity Tabata session",  
    details: "Push your limits with this high-intensity interval training (HIIT) workout featuring 20-second bursts followed by 10 seconds of rest. The format keeps your heart rate elevated and maximizes fat burn. Tabata is known for being efficient — in just 20 minutes, you’ll feel like you’ve had a full workout session."  
  },  
  {  
    id: "workout-8",  
    name: "Upper Body Burn",  
    href: "/workout/",  
    imageSrc: "https://i0.wp.com/www.muscleandfitness.com/wp-content/uploads/2015/05/Walk-Out.jpg?quality=86&strip=all",  
    imageAlt: "Upper body workout",  
    details: "Strengthen and sculpt your arms, shoulders, and back with resistance exercises using dumbbells or bodyweight. Expect a variety of push-ups, presses, rows, and curls to build upper body definition. Improve your posture and overall upper-body endurance."  
  },  
  {  
    id: "workout-9",  
    name: "Morning Stretch Flow",  
    href: "/workout/",  
    imageSrc: "https://d357mttm70bw7x.cloudfront.net/0307a5ce-9d5e-44d8-b2aa-a2f3783fa10c.jpg",  
    imageAlt: "Morning stretch workout",  
    details: "Start your day with a gentle stretching routine to improve flexibility, release tension, and boost circulation. Ideal for waking up the body and mind. This flow focuses on elongating the muscles and increasing mobility."  
  },  
  {  
    id: "workout-10",  
    name: "Leg Day Challenge",  
    href: "/workout/",  
    imageSrc: "https://shop.bodybuilding.com/cdn/shop/articles/leg-workouts-for-men-get-thicker-quads-glutes-and-hams-986493.jpg?v=1737673309",  
    imageAlt: "Leg day workout",  
    details: "Build lower body strength with squats, lunges, and plyometric exercises. Expect to feel the burn as you work your glutes, quads, and hamstrings. This workout increases lower-body strength, power, and stability."  
  }  
];  
